export const getColumnWidth = (column: number, totalColumns: number) => {
  const twoColumnTable = totalColumns === 2

  function defaultColumnWidth() {
    if (totalColumns === 3) {
      return 'w-1/3'
    } else if (totalColumns === 4) {
      return 'w-1/4'
    } else {
      return 'w-full'
    }
  }

  if (column === 0 && twoColumnTable) {
    return 'w-1/3'
  } else if (twoColumnTable) {
    return 'w-2/3'
  } else {
    return defaultColumnWidth()
  }
}
